import { useCallback, useEffect, useState } from "react";
import { getRoom } from "../../components/Twilio/Room/roomService";

/**
 * This hook returns an array of the video room's participants.
 * This will prevent unnecessary re-renders because components
 * that use this hook will only update when a participant connects to or disconnects from the room.
 */

export default function useParticipants() {
    const room = getRoom();
    const [participants, setParticipants] = useState(Array.from(room?.participants.values() || []));

    const participantConnected = useCallback((participant) => setParticipants((prev) => [...prev, participant]), []);

    const participantDisconnected = useCallback((participant) => setParticipants((prev) => prev.filter((p) => p !== participant)), []);

    useEffect(() => {
        if (!room) return;

        room.on("participantConnected", participantConnected);
        room.on("participantDisconnected", participantDisconnected);

        return () => {
            room.off("participantConnected", participantConnected);
            room.off("participantDisconnected", participantDisconnected);
        };
    }, [room, participantConnected, participantDisconnected]);

    return participants;
}
